$(document).ready(function() {
	
  $(".otwieracz").click(function() {
  	$("html").toggleClass('menu-otwarte');
  });
});